const data = {
	"width": 24,
	"height": 24,
	"body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"><path d=\"m8 18l2-2h2l1.36-1.36a6.5 6.5 0 1 0-3.997-3.992L2 18v4h4l2-2v-2Z\"/><circle cx=\"17\" cy=\"7\" r=\"1\"/></g>"
};
exports.__esModule = true;
exports.default = data;
